import { Box, CircularProgress, Typography } from '@mui/material'
import React, { useLayoutEffect, useState } from 'react'
import { useUserPreferences } from '@/features/userSettings/useUserPreferences'
import { BreakoutSection } from '@/layout/BreakoutSection'
import { CardView } from './cardView/CardView'
import { SearchResultsDataGrid } from './datagrid/SearchResultsDataGrid'
import { SearchResultsBar } from './toolbar/SearchResultsBar'
import type { SearchResultDisplay, SearchResultWidth } from './types'

export const SearchResults = () => {
  const {
    searchPreferences: { displayWidth: displayWidthSetting, display },
    updateUserSearchPreferences,
    getRequest: userPrefRequest,
  } = useUserPreferences()

  const [width, setWidth] = useState<SearchResultWidth>(displayWidthSetting)
  const [view, setView] = useState<SearchResultDisplay>(display)

  const Wrapper = width === 'wide' ? BreakoutSection : React.Fragment

  const handleWidthChange = (newWidth: SearchResultWidth) => {
    setWidth(newWidth)
    if (userPrefRequest.isSuccess)
      updateUserSearchPreferences({ displayWidth: newWidth })
  }

  const handleViewChange = (newView: SearchResultDisplay) => {
    setView(newView)
    if (userPrefRequest.isSuccess)
      updateUserSearchPreferences({ display: newView })
  }

  useLayoutEffect(() => {
    setWidth(displayWidthSetting)
  }, [displayWidthSetting])

  useLayoutEffect(() => {
    setView(display)
  }, [display])

  if (userPrefRequest.isLoading)
    return (
      <Box
        display={'grid'}
        sx={{ placeItems: 'center', gap: 1, padding: '6rem', opacity: 0.6 }}
      >
        <CircularProgress />
        <Typography>Loading ...</Typography>
      </Box>
    )

  return (
    <Wrapper>
      <SearchResultsBar
        view={view}
        setView={handleViewChange}
        width={width}
        setWidth={handleWidthChange}
      />

      {view === 'grid' ? <SearchResultsDataGrid /> : <CardView />}
    </Wrapper>
  )
}
